export const countryCodeToLengthMap: Record<string, number> = {
  '+7': 10,
  '+996': 9,
  '+998': 9,
};
